import { Grid } from '@mui/material'
import React from 'react'
import RenderKPIs from './KPI'
import RenderValues from './Values'
interface RenderStatCardsProps {
  activeContractValue: number
  activeMRR: number
  mrrAtRisk30d: number
  dealsEndingSoonCount: number
  dealsWonCount: number
  contractsSentCount: number
  activeProductRevenue: number
}
const RenderStatCards = ({
  activeContractValue,
  activeMRR,
  mrrAtRisk30d,
  dealsEndingSoonCount,
  dealsWonCount,
  contractsSentCount,
  activeProductRevenue,
}: RenderStatCardsProps) => {
  return (
    <Grid container spacing={1.5}>
      <RenderKPIs
        dealsEndingSoonCount={dealsEndingSoonCount}
        contractsSentCount={contractsSentCount}
        dealsWonCount={dealsWonCount}
      />
      <RenderValues
        activeContractValue={activeContractValue}
        activeMRR={activeMRR}
        mrrAtRisk30d={mrrAtRisk30d}
        activeProductRevenue={activeProductRevenue}
      />
    </Grid>
  )
}

export default RenderStatCards
